import { Language } from '@nxt-insurance/constants'

import { CALENDLY_STAGING_LINK } from '@flows/configs/shared/mgaLight/constants'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

import type { PrivatePensionStepParams } from './types'
import { successSchema } from './types'

const getCalendlyPrimaryLink = (params: PrivatePensionStepParams) => {
  if (params.environment === 'production') {
    return params.getCurrentLanguage() === Language.De
      ? 'https://calendly.com/getsafe-leben-gesundheit/leben-gesundheit-av'
      : 'https://calendly.com/getsafe-leben-gesundheit/life-health-av'
  }

  return CALENDLY_STAGING_LINK
}

export const success = (params: PrivatePensionStepParams) => {
  return {
    schema: successSchema,
    stepContent: [
      {
        type: 'animation',
        width: 140,
        height: 140,
        source: require('@ui-kit/assets/animations/check.json') as string,
      },
      {
        type: 'calendly',
        title: {
          type: 'translatableText',
          translationKey: 'sharedFlows_common:steps.success.calendly.title',
        },
        subtitle: {
          type: 'translatableText',
          translationKey: 'sharedFlows_common:steps.success.calendly.subtitle',
        },
        link: getCalendlyPrimaryLink(params),
        bgColor: 'grey100',
      },
    ],
    subFlow: SubFlow.Common,
    onSubmit: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'updateConsultationRequest',
        inputs: [],
        outputs: [],
      },
    },
    hideBackButton: true,
    buttonLabel: {
      type: 'translatableText',
      translationKey: 'sharedFlows_privatePension:steps.success.proceedButtonLabel',
    },
    footer: { hideFooter: true },
    nextStep: 'appointment_details',
  } as const satisfies AnyStepConfiguration
}
